<span class="countdown">
  @if (showDays) {
    <span class="countdown-item">
      <div class="countdown-label">{{ 'days' | translate }}</div>
      <div class="countdown-number">{{ countdown.days }}</div>
    </span>
  }
  <span class="countdown-item">
    <div class="countdown-label">{{ 'hours' | translate }}</div>
    <div class="countdown-number">{{ countdown.hours }}</div>
  </span>
  <span class="countdown-item">
    <div class="countdown-label">{{ 'minutes' | translate }}</div>
    <div class="countdown-number">{{ countdown.minutes }}</div>
  </span>
  <span class="countdown-item">
    <div class="countdown-label">{{ 'seconds' | translate }}</div>
    <div class="countdown-number">{{ countdown.seconds }}</div>
  </span>
</span>
